import React, { createContext, useContext, useMemo } from "react";
import fr from "../locales/fr.json";
import en from "../locales/en.json";

const dictionaries = { fr, en };

const I18nContext = createContext({
  lang: "fr",
  t: (key) => key,
  raw: (key) => null,
});

function resolve(obj, path) {
  return path.split(".").reduce((acc, part) => {
    if (acc === undefined || acc === null) return undefined;
    return acc[part];
  }, obj);
}

export function I18nProvider({ lang, children }) {
  const value = useMemo(() => {
    const dict = dictionaries[lang] || dictionaries.fr;
    const t = (key) => {
      const val = resolve(dict, key);
      if (val === undefined || val === null) return key;
      return typeof val === "string" ? val : key;
    };
    const raw = (key) => resolve(dict, key);
    return { lang, t, raw };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
